module.exports = __webpack_public_path__ + "static/img/jfsc.e53f3a0a.png";